module.exports = __webpack_public_path__ + "media/images/icons/filled/step-forward-41c60121bd38d579d56ad338617af899.svg";